export const allowedRoles = [
  'Admin',
  'BusinessManager',
  'LimitedAdmin',
  'PrimeApprover',
];
